import React, { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAdminAuth } from "../context/AdminAuthContext";

const AdminLoginPage = () => {
  const { admin, login } = useAdminAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  if (admin) {
    return <Navigate to="/admin" replace />;
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email.trim().toLowerCase(), password);
      toast.success("Welcome back, Pritch admin.");
      navigate("/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Login failed. Check your credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] bg-chalk flex items-center" data-testid="admin-login-page">
      <div className="container-x">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
          <div className="md:col-span-5 md:col-start-2 bg-white border border-line p-8 md:p-10">
            <p className="overline mb-4">Admin</p>
            <h1 className="font-display uppercase text-3xl md:text-4xl tracking-tight font-bold leading-[1]">
              Pritch Operator Console
            </h1>
            <p className="mt-4 text-mute text-sm">Sign in to manage orders, enquiries, reviews and product imagery.</p>

            <form onSubmit={onSubmit} className="mt-8 space-y-5" data-testid="admin-login-form">
              <div>
                <label className="overline block mb-2">Email</label>
                <input
                  required
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full border border-line px-4 py-3 bg-chalk focus:outline-none focus:border-ink"
                  data-testid="admin-login-email"
                />
              </div>
              <div>
                <label className="overline block mb-2">Password</label>
                <input
                  required
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full border border-line px-4 py-3 bg-chalk focus:outline-none focus:border-ink"
                  data-testid="admin-login-password"
                />
              </div>
              {error && (
                <p className="text-xs text-red-600 mono" data-testid="admin-login-error">
                  {error}
                </p>
              )}
              <button
                type="submit"
                disabled={loading}
                className="btn-primary w-full"
                data-testid="admin-login-submit"
              >
                {loading ? "Signing in…" : "Sign in"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLoginPage;
